import React from 'react';
import ZentorgaForm from '../components/ZentorgaForm';
import BenefitPeriod from '../../components/BenefitPeriod';
import KeepButton from '../components/KeepButton';
import SoundVideo from '../components/SoundVideo';
import { useFormSubmit } from '../hooks/useFormSubmit';
import { useMultiStep } from '../hooks/useMultiStep';
import { getImagesByStep } from '../utils/templateMapper';
import '../styles/zentorga.scss';
import '../styles/template23.scss';

/**
 * Template23 - 두 단계 폼 (NO SURVEYS)
 * 구조:
 * Page 1: 이미지(1개) → Keep 버튼
 * Page 2: 이미지(5개) → 혜택기간 → 폼 → 서비스정보(선택) → 푸터
 */
const Template23 = ({
  landingData,
  urlCode,
  urlCodeSettingId
}) => {
  const { currentStep, goToNextStep } = useMultiStep(2);
  const { handleSubmit, isSubmitting } = useFormSubmit(
    urlCode,
    urlCodeSettingId,
    landingData.endpoint
  );

  const stepImages = getImagesByStep(landingData, 2);

  return (
    <section className="template23-layout zentorga-layout">
      {/* Step 1: Single Image + Keep Button */}
      {currentStep === 0 && (
        <div className="page-container page1">
          {stepImages.step1.length > 0 && (
            <div className="template23-images zentorga-images">
              {stepImages.step1.map((img, idx) => {
                const fileExtension = img.url.split('.').pop().toLowerCase();
                const isVideo = ['mp4', 'webm', 'ogg', 'mov'].includes(fileExtension);

                return isVideo ? (
                  <SoundVideo key={idx} src={img.url} loop={img.alt !== "false"} />
                ) : (
                  <img key={idx} src={img.url} alt={img.alt} />
                );
              })}
            </div>
          )}

          {/* Keep Button */}
          <KeepButton
            onClick={() => goToNextStep()}
            imageUrl={landingData.keepBtnUrl}
            text={landingData.keepBtnText || '계속하기'}
          />
        </div>
      )}

      {/* Step 2: Images + Benefit Period + Form */}
      {currentStep === 1 && (
        <div className="page-container page2">
          {/* Page 2 Images */}
          {stepImages.step2.length > 0 && (
            <div className="template23-images zentorga-images">
              {stepImages.step2.map((img, idx) => {
                const fileExtension = img.url.split('.').pop().toLowerCase();
                const isVideo = ['mp4', 'webm', 'ogg', 'mov'].includes(fileExtension);

                return isVideo ? (
                  <SoundVideo key={idx} src={img.url} loop={img.alt !== "false"} />
                ) : (
                  <img key={idx} src={img.url} alt={img.alt} />
                );
              })}
            </div>
          )}

          {/* 이벤트 대상자 */}
          {landingData.eventTarget && (
            <div className="eventTarget">
              <p>이벤트 대상자 : <span className="event-target-text">{landingData.eventTarget}</span></p>
            </div>
          )}

          {/* Benefit Period */}
          {landingData.benefitDate && (
            <div className="benefitDate">
              <BenefitPeriod periodType={landingData.benefitDate} />
            </div>
          )}

          {/* Form Section */}
          <div className="formStyleClassName">
            <ZentorgaForm
              onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
              formStyle={landingData.formStyleClassName || 'gray'}
              consentStyle={landingData.privacyPolicyClassName || 'dark'}
              privacyPolicyName={landingData.privacyPolicyName || '본원'}
              privacyPolicy={landingData.privacyPolicy}
              marketingPolicy={landingData.marketingPolicy}
              buttonComponent={
                <button
                  type="submit"
                  className={`postBtn ${landingData.postBtnLocate === 'fixed' ? 'postBtn-fixed' : ''}`}
                  id="postBtn"
                  disabled={isSubmitting}
                >
                  {landingData.postBtnUrl ? (
                    <img src={landingData.postBtnUrl} alt="신청하기" />
                  ) : (
                    <span>{isSubmitting ? '신청 중...' : '신청하기'}</span>
                  )}
                </button>
              }
            />
          </div>

          {/* Service Info */}
          {landingData.serviceInfoClassName && (
            <p
              className={`serviceInfoClassName ${landingData.serviceInfoClassName}`}
              id="serviceInfoClassName"
            >
              * 본 서비스는 전국 20여 개 이상의 제휴 병원에서 제공되며,<br />
              상담 신청 정보를 기반으로 전문 상담원이 적합한 제휴 병원을 안내해드립니다.
            </p>
          )}
        </div>
      )}

      {/* Footer (outside steps) */}
      {landingData.footerClassName !== null && (landingData.footerClassName !== undefined || landingData.footerDetail) && (
        <footer className={`footerClassName ${landingData.footerClassName || ''}`}>
          {landingData.footerDetail && (
            <p className="footerDetail" style={{ whiteSpace: 'pre-line' }}>
              {landingData.footerDetail}
            </p>
          )}
        </footer>
      )}
    </section>
  );
};

export default Template23;
